.document-container.odd-line{background-color:#f9f9f9}.document-container.even-line{background-color:#e9e9e9}.document-container{margin:1em}.document-container-top{margin-top:0!important}
/*# sourceMappingURL=admission-documents.component-WESC3NO5.css.map */
